import { render, staticRenderFns } from "./InputableRadio.vue?vue&type=template&id=946a2452&scoped=true"
import script from "./InputableRadio.vue?vue&type=script&lang=js"
export * from "./InputableRadio.vue?vue&type=script&lang=js"
import style0 from "./InputableRadio.vue?vue&type=style&index=0&id=946a2452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946a2452",
  null
  
)

export default component.exports